export enum Environments {
	All = 'All',
	Web = 'Web',
	App = 'App',
}

export type Environment = Environments.All | Environments.Web | Environments.App;
